import { render, staticRenderFns } from "./ViewsDetailsModal.vue?vue&type=template&id=064c2acc&scoped=true"
import script from "./ViewsDetailsModal.vue?vue&type=script&lang=js"
export * from "./ViewsDetailsModal.vue?vue&type=script&lang=js"
import style0 from "./ViewsDetailsModal.vue?vue&type=style&index=0&id=064c2acc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "064c2acc",
  null
  
)

export default component.exports